import script from "./FilialCertificadoFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./FilialCertificadoFrame.vue?vue&type=script&setup=true&lang=js"

import "./FilialCertificadoFrame.vue?vue&type=style&index=0&id=0b95474c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b95474c"]])

export default __exports__